var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MessagingError, MessagingAPIError } from './utils';
var defaultOptions = {
    baseUrl: 'https://messaging.example.com/api/core/v1/apps/2/',
    fetch: undefined,
};
var pathMap = {
    createMessage: 'messages/',
    deleteMessage: 'messages/{{messageId}}/',
    getMessageDetails: 'messages/{{messageId}}/',
    listMessages: 'messages/',
};
var MessagingClient = /** @class */ (function () {
    function MessagingClient(identity, options) {
        var _this = this;
        this.identity = identity;
        this.getAuthHeader = function () {
            return _this.identity.jwt ? "Bearer " + _this.identity.jwt : "Token " + _this.identity.apiKey;
        };
        this.createMessage = function (body) { return __awaiter(_this, void 0, void 0, function () {
            var audienceType, content, groups, isRecurring, metadata, ownerId, payloadOptions, recurringOffset, recurringUnit, recurringEndDatetime, scheduledDatetime, scheduleType, title, users, url, formData, resp, rawMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        audienceType = body.audienceType, content = body.content, groups = body.groups, isRecurring = body.isRecurring, metadata = body.metadata, ownerId = body.ownerId, payloadOptions = body.payloadOptions, recurringOffset = body.recurringOffset, recurringUnit = body.recurringUnit, recurringEndDatetime = body.recurringEndDatetime, scheduledDatetime = body.scheduledDatetime, scheduleType = body.scheduleType, title = body.title, users = body.users;
                        url = this.getUrl('createMessage', ownerId ? "?owner_id=" + ownerId + "&filter_by_owner=false" : undefined);
                        formData = new FormData();
                        formData.append('audience_type', audienceType);
                        formData.append('content', content);
                        formData.append('metadata', JSON.stringify(metadata));
                        formData.append('payload_options', JSON.stringify(payloadOptions));
                        formData.append('scheduled_datetime', scheduledDatetime);
                        formData.append('schedule_type', scheduleType);
                        formData.append('title', title);
                        if (isRecurring && recurringOffset && recurringUnit) {
                            formData.append('is_recurring', '1');
                            formData.append('recurring_offset', "" + recurringOffset);
                            formData.append('recurring_unit', recurringUnit);
                            if (recurringEndDatetime) {
                                formData.append('recurring_end_datetime', recurringEndDatetime);
                            }
                        }
                        if (users) {
                            users.forEach(function (identity) { return formData.append('identities', identity); });
                        }
                        if (groups) {
                            groups.forEach(function (groupId) { return formData.append('group_ids', groupId); });
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'POST',
                                headers: {
                                    Authorization: this.getAuthHeader(),
                                },
                                body: formData,
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw MessagingAPIError('Unable to create message', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        rawMessage = (_a.sent()).result;
                        return [2 /*return*/, this.mapRawMessage(rawMessage)];
                }
            });
        }); };
        this.deleteMessage = function (messageId) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('deleteMessage');
                        return [4 /*yield*/, this.fetch(url.replace('{{messageId}}', messageId), {
                                method: 'DELETE',
                                headers: {
                                    Authorization: this.getAuthHeader(),
                                },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw MessagingAPIError('Unable to delete message', resp);
                        }
                        return [2 /*return*/, resp.ok];
                }
            });
        }); };
        this.getMessageDetails = function (messageId) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('getMessageDetails');
                        return [4 /*yield*/, this.fetch(url.replace('{{messageId}}', messageId), {
                                method: 'GET',
                                headers: {
                                    Authorization: this.getAuthHeader(),
                                },
                            })];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw MessagingAPIError('Unable to get message details', resp);
                        }
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.listMessages = function (page, ownerId, status) { return __awaiter(_this, void 0, void 0, function () {
            var url, resp, _a, pagination, result;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = this.getUrl('listMessages');
                        return [4 /*yield*/, this.fetch(url + "?page=" + (page || 1) + (ownerId ? "&owner_id=" + ownerId : '') + (status ? "&status=" + status : ''), {
                                method: 'GET',
                                headers: {
                                    Authorization: this.getAuthHeader(),
                                },
                            })];
                    case 1:
                        resp = _b.sent();
                        if (!resp.ok) {
                            throw MessagingAPIError('Unable to get list of messages', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        _a = _b.sent(), pagination = _a.pagination, result = _a.result;
                        return [2 /*return*/, {
                                nextPage: this.getNextPage(pagination.num_pages, pagination.current_page),
                                result: result.map(function (message) { return _this.mapRawMessage(message); }),
                            }];
                }
            });
        }); };
        if (!identity.jwt && !identity.apiKey) {
            throw MessagingError('You must specify a JWT or API Key');
        }
        if (!options) {
            this.options = defaultOptions;
        }
        else {
            this.options = __assign(__assign({}, defaultOptions), options);
            if (!this.options.baseUrl) {
                this.options.baseUrl = defaultOptions.baseUrl;
            }
        }
        this.fetch = this.options.fetch || window.fetch.bind(window);
    }
    MessagingClient.prototype.getUrl = function (endpoint, queryString) {
        var result;
        result = "" + this.options.baseUrl + pathMap[endpoint] + (queryString || '');
        return result;
    };
    MessagingClient.prototype.getNextPage = function (totalPages, currentPage) {
        if (currentPage < totalPages) {
            return currentPage + 1;
        }
        return null;
    };
    MessagingClient.prototype.mapRawMessage = function (rawMessage) {
        var isDeleted = rawMessage.is_deleted, isSent = rawMessage.is_sent, audienceType = rawMessage.audience_type, audienceDisplay = rawMessage.audience_display, scheduleType = rawMessage.schedule_type, scheduledDatetime = rawMessage.scheduled_datetime, nextSendDatetime = rawMessage.next_send_datetime, lastSentDatetime = rawMessage.last_sent_datetime, isRecurring = rawMessage.is_recurring, recurringOffset = rawMessage.recurring_offset, recurringUnit = rawMessage.recurring_unit, shouldIncreaseBadge = rawMessage.should_increase_badge, payloadOptions = rawMessage.payload_options, ownerId = rawMessage.owner_id, rest = __rest(rawMessage, ["is_deleted", "is_sent", "audience_type", "audience_display", "schedule_type", "scheduled_datetime", "next_send_datetime", "last_sent_datetime", "is_recurring", "recurring_offset", "recurring_unit", "should_increase_badge", "payload_options", "owner_id"]);
        return __assign(__assign({}, rest), { isDeleted: isDeleted,
            isSent: isSent,
            audienceType: audienceType,
            audienceDisplay: audienceDisplay,
            scheduleType: scheduleType,
            scheduledDatetime: scheduledDatetime,
            nextSendDatetime: nextSendDatetime,
            lastSentDatetime: lastSentDatetime,
            isRecurring: isRecurring,
            recurringOffset: recurringOffset,
            recurringUnit: recurringUnit,
            shouldIncreaseBadge: shouldIncreaseBadge,
            payloadOptions: payloadOptions,
            ownerId: ownerId });
    };
    MessagingClient.prototype.sub = function () {
        // Get the body of the JWT.
        if (this.identity.jwt) {
            var payload = this.identity.jwt.split('.')[1];
            // Which is base64 encoded.
            var parsed = JSON.parse(atob(payload));
            return parsed.sub;
        }
        return '';
    };
    return MessagingClient;
}());
export default MessagingClient;
//# sourceMappingURL=client.js.map